import {
  invoiceStatuses,
  invoiceTypes,
  type InvoiceInsertSchema,
} from "@adva/types";
import {
  enumOptions,
  type EntityFieldConfig,
} from "@/components/v2/entity-form-config";

export type InvoiceFormValues = (typeof InvoiceInsertSchema)["_output"];

export function invoiceFields(
  customerOptions: { value: string; label: string }[],
): EntityFieldConfig<InvoiceFormValues>[] {
  return [
    {
      name: "customer_role_id",
      label: "Customer",
      control: "select",
      required: true,
      options: customerOptions,
      emptyOptionLabel: "Select customer",
    },
    {
      name: "invoice_number",
      label: "Invoice number",
      control: "text",
      required: true,
    },
    {
      name: "status",
      label: "Status",
      control: "select",
      options: enumOptions(invoiceStatuses),
    },
    {
      name: "invoice_type",
      label: "Invoice type",
      control: "select",
      emptyOptionLabel: "Unspecified",
      options: enumOptions(invoiceTypes),
    },
    {
      name: "due_date",
      label: "Due date",
      control: "text",
      placeholder: "YYYY-MM-DD",
    },
    { name: "notes", label: "Notes", control: "textarea" },
  ];
}

export function invoiceToFormValues(
  inv: Record<string, unknown> | undefined,
): Partial<InvoiceFormValues> {
  if (!inv) return {};
  const str = (v: unknown): string | undefined =>
    typeof v === "string" && v.length > 0 ? v : undefined;
  return {
    customer_role_id: str(inv.customer_role_id),
    invoice_number: str(inv.invoice_number),
    status: (str(inv.status) as InvoiceFormValues["status"]) ?? "draft",
    invoice_type: str(inv.invoice_type) as InvoiceFormValues["invoice_type"],
    due_date: str(inv.due_date),
    notes: str(inv.notes),
  };
}
